module.exports = __webpack_public_path__ + "img/emoticon-nps-5-off.007515bc.svg";